export default __webpack_public_path__ + "static/media/ASLTIP-logo.93c66489.png";